var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"err-container"},[_c('img',{attrs:{"src":require("../../assets/image/500.png"),"alt":""}}),_c('div',{staticClass:"info-text"},[_vm._v("抱歉，服务器出错了")])])
}]

export { render, staticRenderFns }